import type {OrderDetailsData} from 'modules/Orders/types';

import {Loading, Modal} from '@ds/components';
import {DetailPageLayout} from '@ds/layout';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getOrder} from 'store/slices/order/thunk';
import {getSelectedVendorFromStorage} from 'utils/Helper';

import CouponItem from './components/CouponItem/CouponItem';
import CustomerInfo from './components/CustomerInfo/CustomerInfo';
import OrderProducts from './components/OrderProducts/OrderProducts';
import OrderSummary from './components/OrderSummary/OrderSummary';
import RevisedOrderNotice from './components/RevisedOrderNotice/RevisedOrderNotice';

const OrderDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const {orderId} = useParams();
  const vendorId = getSelectedVendorFromStorage()?.id ?? '0';
  const {order: orderState, loading} = useAppSelector((state) => state.order);
  const order = orderState as OrderDetailsData;
  const [isRevisedOrderOpen, setIsRevisedOrderOpen] = useState(false);

  useEffect(() => {
    if (!orderId) {
      return;
    }

    void dispatch(getOrder({orderId, vendor_id: vendorId}));
  }, [dispatch, orderId, vendorId]);

  return (
    <DetailPageLayout id="order-details-content">
      {loading ? (
        <div className="flex flex-1 items-center justify-center">
          <Loading size="medium" />
        </div>
      ) : (
        <div className="flex flex-col bg-white">
          <CustomerInfo
            customerName={order.current?.customer_name}
            orderCode={order.current?.order_code}
            orderDate={order.current?.order_date}
            orderStatus={order.current?.order_status}
          />
          <OrderSummary
            revised
            discount={order.current?.discount}
            totalGoodsAmount={order.current?.total_goods_amount}
            vendorRevenue={order.current?.vendor_revenue}
            revenueDiff={order.current?.revenue_diff}
            customerComment={order.current?.customer_comment}
          />
          {order.current?.order_coupon && <CouponItem data={order.current.order_coupon} />}
          {order.revised && <RevisedOrderNotice onClick={() => setIsRevisedOrderOpen(true)} />}
          {order.current && <OrderProducts data={order.current} />}

          <Modal
            show={isRevisedOrderOpen}
            onClose={() => setIsRevisedOrderOpen(false)}
            fullScreen
            defaultHeader
            title="فاکتور قبلی"
          >
            {order.revised && <OrderProducts data={order.revised} />}
          </Modal>
        </div>
      )}
    </DetailPageLayout>
  );
};

export default OrderDetails;
